import { useRealtimeStatusMessage } from '@ngsos/portal-core/portal';

import { RealtimeConnectionStatusBanner } from '@/ui';

export function RealtimeConnectionStatusBar() {
  const message = useRealtimeStatusMessage();

  return <RealtimeConnectionStatusBanner message={message} />;
}
